import isNumber from 'lodash/isNumber';

import { isNonEmptyString } from './isNonEmptyString';

export const isNonEmptyStringOrNumber = (
  value: unknown,
): value is string | number => isNonEmptyString(value) || isNumber(value);
